import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Text, TextButton, Toast, Tooltip } from '@modusign/design-system';
import moment from 'moment';
import { useCopyToClipboard } from 'react-use';

import useWorkspaceLabel from '@app/features/label/hooks/useResourceLabel';

import LabelBasicInfoPanel from './LabelBasicInfoPanel';

interface LabelBasicInfoTabPanelProps {
  id: string;
  onBack: () => void;
}

export default function LabelBasicInfoTabPanel({ id, onBack }: LabelBasicInfoTabPanelProps) {
  const [, copy] = useCopyToClipboard();
  const { data: label } = useWorkspaceLabel(id);

  if (!label) {
    // 상위 컴포넌트에서 로딩, 오류처리합니다.
    return null;
  }

  return (
    <>
      <LabelBasicInfoPanel id={id} onBack={onBack} />
      <Box bg="boxBackgroundNeutralSlightlyLight" mt={7} p={5}>
        <Text
          as="div"
          color={label.member ? 'textNeutralLight' : 'textNeutralUltraLight'}
          fontSize="xs"
        >
          생성자 : {label.member?.name || '정보 없음'}
        </Text>
        <Text as="div" color="textNeutralLight" fontSize="xs" mt={2}>
          생성일 : {moment(label.createdAt).format('YYYY. MM. DD.')}
        </Text>
      </Box>
      <Text as="div" color="textNeutralLight" fontSize="xs" mt={6}>
        Label ID : {label.id}
        <Tooltip content="ID 복사">
          <TextButton
            ml={3}
            p="3px"
            onClick={() => {
              copy(label.id);
              Toast.success({ description: 'ID를 복사했습니다.' });
            }}
          >
            <Box as={FontAwesomeIcon} icon={faCopy} />
          </TextButton>
        </Tooltip>
      </Text>
    </>
  );
}
